/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ImpersonateUserInput = {
    userId: string;
    accountId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type UserListRowImpersonateUserMutationVariables = {
    input: ImpersonateUserInput;
};
export type UserListRowImpersonateUserMutationResponse = {
    readonly impersonateUser: {
        readonly clientMutationId: string | null;
    } | null;
};
export type UserListRowImpersonateUserMutation = {
    readonly response: UserListRowImpersonateUserMutationResponse;
    readonly variables: UserListRowImpersonateUserMutationVariables;
};



/*
mutation UserListRowImpersonateUserMutation(
  $input: ImpersonateUserInput!
) {
  impersonateUser(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImpersonateUserPayload",
    "kind": "LinkedField",
    "name": "impersonateUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserListRowImpersonateUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserListRowImpersonateUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "400eed672720abf8acf8683af19a0c53",
    "id": null,
    "metadata": {},
    "name": "UserListRowImpersonateUserMutation",
    "operationKind": "mutation",
    "text": "mutation UserListRowImpersonateUserMutation(\n  $input: ImpersonateUserInput!\n) {\n  impersonateUser(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c35934eba14d7f07a8aa0ed3cfce080a';
export default node;
